module.exports = __webpack_public_path__ + "static/media/img-tag-moduleC1.668092f0.png";